
import React, { useEffect } from 'react';
// Fix: Use namespace import to bypass missing exported member errors in react-router-dom
import * as ReactRouterDom from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { Loader2, ShieldCheck } from 'lucide-react';

const { useNavigate } = ReactRouterDom as any;

/**
 * Modern Handshake Landing Zone.
 * Optimized for reliability on self-hosted stacks.
 */
const AuthCallback: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let timeout: any;
    
    const checkSession = async () => {
      // Small delay to let the SDK finish hashing the URL params
      const { data: { session } } = await supabase.auth.getSession();
      if (session) {
        navigate('/', { replace: true });
      } else {
        // If no session found yet, wait for the state change listener
        const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
          if (session) {
            subscription.unsubscribe();
            navigate('/', { replace: true });
          }
        });

        // Fail-safe timeout increased to 15s for self-hosted robustness
        timeout = setTimeout(() => {
          subscription.unsubscribe();
          navigate('/login?error=Authentication%20Timeout', { replace: true });
        }, 15000);
      }
    };

    checkSession();
    return () => clearTimeout(timeout);
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#F8FAFC]">
      <div className="w-24 h-24 bg-slate-900 rounded-[2rem] flex items-center justify-center mb-10 shadow-2xl animate-pulse">
        <ShieldCheck size={48} className="text-[#FFDB00]" />
      </div>
      <div className="flex flex-col items-center gap-4 text-center">
        <div className="flex items-center gap-3">
          <Loader2 size={24} className="text-slate-900 animate-spin" />
          <h2 className="text-sm font-bold uppercase tracking-[0.4em] text-slate-900">
            Establishing Secure Link
          </h2>
        </div>
        <p className="text-[10px] text-slate-400 font-bold uppercase tracking-widest max-w-xs leading-relaxed">
          Verifying Identity Handshake with Database.
        </p>
      </div>
    </div>
  );
};

export default AuthCallback;
